export default __webpack_public_path__ + "static/media/collab_light.4d256dfb.svg";